import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ConfigurationService } from '../shared/configuration/configuration.service';
import { AuthService } from './auth.service';
import { reject } from 'q';

@Injectable()
export class StartupService {

  constructor(private _configurationService: ConfigurationService
    , private _authService: AuthService) {
  }

  load() {
    // return this._configurationService.getConfigurations();
    if (this._authService.isLoginCallback) {
      return new Promise((resolve, reject) => {
        this._authService.completeAuthentication().then(value => {
          resolve(true);
        }).catch(error => {
          console.log(error);
          resolve(error);
        });
      });
    }
    else if (!this._authService.isLoggedIn()) {
      return this._authService.startAuthentication();
    }
    else {
      return new Promise((resolve, reject) => {
        resolve('User already logged in...');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/startup/startup.service.ts